import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';
import { handleUnselectedProduct } from '../utils/updateMedicationPadItems';

export const removeMedicationPadItemById: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (medicationPadItemId: string) => void
> = (set, get) => (medicationPadItemId) => {
  const { prescriptionAssistant, updatePrescriptionHistoryItemsToReissue, updatePrescriptionHistoryItemsToCancel } =
    get();

  const itemToRemove = prescriptionAssistant.prescriptionPad.medicationPadItems.find(
    (item) => item.medicationPadItemId === medicationPadItemId
  );

  if (itemToRemove?.medicationPadItem) {
    const { updatedCancelledItems, updatedReissuedItems } = handleUnselectedProduct(
      itemToRemove.medicationPadItem?.productId,
      prescriptionAssistant.prescriptionHistory.previousItems,
      prescriptionAssistant.prescriptionHistory.itemsToReissue,
      prescriptionAssistant.prescriptionHistory.itemsToCancel
    );
    updatePrescriptionHistoryItemsToCancel(updatedCancelledItems);
    updatePrescriptionHistoryItemsToReissue(updatedReissuedItems);
  }
  set(
    (state) => {
      state.prescriptionAssistant.prescriptionPad.medicationPadItems =
        state.prescriptionAssistant.prescriptionPad.medicationPadItems.filter(
          (item) => item.medicationPadItemId !== medicationPadItemId
        );
    },
    false,
    'prescriptionPad/removeMedicationPadItemById'
  );
};
